// src/components/PanelMissions/PanelMissions.jsx
import { useDispatch } from "react-redux";
import { PanelNav }   from "../Bootoverlay/Bootoverlay";
import { openModal }  from "../Paneltours/PanelTourSlice/PanelTourSlice";

export const MISSIONS = [
  {
    id: "the-strip",
    num: "T-01",
    name: "THE STRIP",
    route: "Las Vegas Blvd · Day & Night",
    thrill: 4,
    duration: "~1.5 HRS",
    karts: "2-6",
    terrain: "URBAN",
    price: 200,
    desc: "The flagship run. Down the Strip. Past the casinos. Under the neon. The route every driver has to do at least once.",
    color: "orange",
    bg: "/images/strip_kart.png",
  },
  {
    id: "downtown",
    num: "T-02",
    name: "DOWNTOWN",
    route: "Fremont · Art District",
    thrill: 3,
    duration: "~1.5 HRS",
    karts: "2-6",
    terrain: "URBAN",
    price: 150,
    desc: "Historic Las Vegas. Real Streets. Real Art. Open-air through Old Vegas' grid. Where the city started.",
    color: "orange",
    bg: "/images/fremont_kart.png",
  },
  {
    id: "red-rock",
    num: "T-03",
    name: "RED ROCK",
    route: "Red Rock Canyon · Desert Circuit",
    thrill: 5,
    duration: "~2 HRS",
    karts: "2-6",
    terrain: "CANYON",
    price: 150,
    desc: "Out of the city. Into the canyon. Red Rock's curves and elevation changes give you a completely different kind of drive.",
    color: "orange",
    bg: "/images/redrock_kart.png",
    comingSoon: true,
  },
  {
    id: "lake-lv",
    num: "T-04",
    name: "LAKE LV",
    route: "Lake Las Vegas · Waterfront Loop",
    thrill: 2,
    duration: "~2 HRS",
    karts: "2-6",
    terrain: "SCENIC",
    price: 150,
    desc: "The relaxed run. Waterfront roads, mountain views, lower traffic density.",
    color: "orange",
    bg: "/images/lakelv_kart_1.png",
    comingSoon: true,
  },
];

export default function PanelTours({ onNav }) {
  const dispatch = useDispatch();

  return (
    <section className="vk-panel vk-panel-missions" id="panel-tours">
      <div className="vk-missions-layout-wrapper">

        {/* LEFT COLUMN */}
        <div className="vk-missions-left-col">
          <div className="vk-missions-header">
            <div className="vk-section-eyebrow">
              <span className="vk-eyebrow-num">04</span>
              <span>//</span>
              <span>TOUR SELECT</span>
            </div>
            <h2 className="vk-section-title" style={{ borderBottom: "none" }}>
              SELECT YOUR<br />
              <span className="orange">TOUR</span>
            </h2>
            <p className="vk-section-sub">
              Schedule your tour today. Missions commence Winter 2026. Valid driver's license required. Age 21+
            </p>
          </div>
          <div className="vk-left-nav-wrappers">
            <PanelNav prev={2} next={4} label="04 / 08 — TOURS" onNav={onNav} />
          </div>
        </div>

        {/* RIGHT COLUMN — 2×2 card grid */}
        <div className="vk-mission-grid">
          {MISSIONS.map((m, idx) => (
            <div
              key={m.id}
              className={`vk-mission-card${m.featured ? " featured" : ""}${m.comingSoon ? " coming-soon" : ""} accent-${m.color}`}
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              {m.bg && (
                <div className="vk-card-bg-photo" style={{ backgroundImage: `url(${m.bg})` }} />
              )}

              {m.comingSoon && (
                <div className="vk-coming-soon-banner"><span>⚡ COMING SOON</span></div>
              )}

              <div className="vk-mission-card-header">
                <span className="vk-mission-number">{m.num}</span>
                {m.featured && <span className="vk-mission-badge">★ FLAGSHIP</span>}
              </div>

              <div className="vk-mission-name-wrap">
                <div className="vk-mission-name">{m.name}</div>
                <div className="vk-mission-route">{m.route}</div>
              </div>

              <div className="vk-mission-diff">
                <span className="vk-diff-label">THRILL LEVEL</span>
                <div className="vk-diff-stars">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <span key={s} className={`vk-star${s <= m.thrill ? ` filled accent-${m.color}` : ""}`}>★</span>
                  ))}
                </div>
              </div>

              <div className="vk-mission-stats">
                {[
                  ["DURATION",     m.duration],
                  ["KARTS PER TOUR", m.karts],
                  ["TERRAIN",      m.terrain],
                ].map(([k, v]) => (
                  <div key={k} className="vk-mstat">
                    <div className="vk-mstat-label">{k}</div>
                    <div className="vk-mstat-val">{v}</div>
                  </div>
                ))}
              </div>

              <p className="vk-mission-desc">{m.desc}</p>

              <div className="vk-mission-price">
                <span className="vk-price-tag">${m.price}</span>
                <span className="vk-price-sub">/DRIVER · PRE-ORDER</span>
              </div>

              <button
                className={`vk-btn-mission accent-${m.color}${m.comingSoon ? " disabled" : ""}`}
                onClick={() => !m.comingSoon && dispatch(openModal({ id: m.id, name: m.name, price: m.price }))}
                disabled={m.comingSoon}
              >
                {m.comingSoon ? "COMING SOON ▶" : "BOOK TOUR ▶"}
              </button>

              <div className="vk-mission-deploy">⚡ DEPLOYMENT: WINTER 2026</div>
              <div className={`vk-mission-glow accent-${m.color}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}